import { useUserLanguage } from '@/customHooks';
import { useCreatePropertyContext } from '@/customHooks/useCreatePropertyContext';
import { Col, Row } from 'react-grid-system';
import styled from 'styled-components';
import textsData from '@/textData/CreatePropertyTexts.json'
import { propertyTypeMapper } from '@/helpers/propertyTypeMapper';
import { useGetCityWithStateAndCountryNamesQuery } from '@/graphql/generated';
import { Fragment } from 'react/jsx-runtime';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.light};
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: 2rem 3rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
`

const Label = styled.label`
  font-size: 15px;
  font-weight: 600;
  padding: 0px 50px 0 5px;
  color: ${({ theme }) => theme.colors.text};
  line-height: normal;
`;

const Input = styled.input`
  background: ${({ theme }) => theme.colors.background2};
  border: none;
  border-radius: ${({ theme }) => theme.border.radius.md};
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #212121;
  width: 100%;
  box-sizing: border-box;
`;

const UnitiesTextsContainer = styled(Col)`
  padding-top: 1rem;
  padding-bottom: 1rem;
  > span {
    font-weight: 600;
    font-size: 15px;
  }
`

export const CreatePropertyConfirmationDialog = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.confirmationDialog : textsData.en.confirmationDialog

  const { state, ownerData } = useCreatePropertyContext()

  const { data, loading } = useGetCityWithStateAndCountryNamesQuery({ variables: { cityId: state.cityId }})

  return (
    <Wrapper>
      <Row align='center'>
        <Col >
          <Label htmlFor="name">{texts.name}</Label>
        </Col>
        <Col md={7}>
          <Input id="name" readOnly value={state.name} />
        </Col>
      </Row>
      <br />
      <Row align='center'>
        <Col>
          <Label htmlFor="type">{texts.type}</Label>
        </Col>
        <Col md={7}>
          <Input id="type" readOnly value={propertyTypeMapper(state.propertyType, userLanguage) } />
        </Col>
      </Row>
      <br />
      <Row align='center'>
        <Col>
          <Label htmlFor="name">{texts.owner}</Label>
        </Col>
        <Col md={7}>
          <Input id="name" readOnly value={`${ownerData?.firstName} ${ownerData?.lastName}`} />
        </Col>
      </Row>
      <br />
      <Row align='center'>
        <Col>
          <Label htmlFor="name">{texts.address}</Label>
        </Col>
        <Col md={7}>
          <Input
            id="name"
            readOnly
            value={
              loading
              ? 'Loading...'
              : `${state.street}, ${data?.city.name || ''}, ${data?.city.state?.name || ''} ${data?.city.country?.name || ''}`
            } />
        </Col>
      </Row>
      <hr />
      <Row>
        <UnitiesTextsContainer>
          <span>
            {texts.unities}
          </span>
        </UnitiesTextsContainer>
      </Row>
      {
        state.unities?.map((unity, index) => (
          <Fragment key={index + unity.name}>
            <Row align='center'>
              <Col>
                <Label htmlFor={'unityname'.concat(index.toString())}>{index + 1}</Label>
              </Col>
              <Col md={7}>
                <Input id={'unityname'.concat(index.toString())} readOnly value={unity.name} />
              </Col>
            </Row>
            <br />
          </Fragment>
        ))
      }
    </Wrapper>
  )
}